import React, { useState } from "react";
import { Card, Container, Button, Collapse } from "react-bootstrap";
import { useTheme } from "../ThemeContext";
import "./DownloadPage.css";

const DownloadPage = () => {
  const { isDarkMode } = useTheme();
  const themeClass = isDarkMode ? "bg-dark text-light" : "bg-light text-dark";
  const [showPrevious, setShowPrevious] = useState(false);

  // Current Release (v2.0.0)
  const current = {
    version: "2.0.0",
    releaseDate: "10/9/2026",
    github:
      "https://github.com/BusinessTSG/Pipsqueak/releases/download/v2.0.0/Pipsqueak-v2.0.0-windows-x64.exe",
    s3:
      "https://myexefilebucket.s3.eu-north-1.amazonaws.com/Pipsqueak-v2.0.0-windows-x64.exe",
    sha256: "24c18c4dd3ece4f1c25813aa44df49e5e4c3f856d5a7ff29392a674662250c4b",
    vt: "https://www.virustotal.com/gui/file/24c18c4dd3ece4f1c25813aa44df49e5e4c3f856d5a7ff29392a674662250c4b",
  };

  // Previous Releases
  const previousVersions = [
     {
    version: "1.4.9",
    github:
      "https://github.com/BusinessTSG/Pipsqueak-Network-Scanner/releases/download/v1.4.9/Pipsqueak-windows-x64-latest.exe",
    s3:
      "https://myexefilebucket.s3.eu-north-1.amazonaws.com/Pipsqueak-windows-x64-latest.exe",
    sha256: "025be58c6bacf184448bfc9c2c04f965811804d0cc930e275d81aba849620510",
    vt: "https://www.virustotal.com/gui/file/025be58c6bacf184448bfc9c2c04f965811804d0cc930e275d81aba849620510",
  },
    {
    version: "1.4.8.2",
    github:
      "https://github.com/BusinessTSG/Pipsqueak-Network-Scanner/releases/download/v1.4.8.2/Pipsqueak-windows-x64-latest.exe",
    s3:
      "https://myexefilebucket.s3.eu-north-1.amazonaws.com/Pipsqueak-windows-x64-1.4.8.2.exe",
    sha256: "645ca4a1ee15a8b5953d45dee6953e91ca39ea18e41728b7be956b7a7be41d77",
    vt: "https://www.virustotal.com/gui/file/645ca4a1ee15a8b5953d45dee6953e91ca39ea18e41728b7be956b7a7be41d77",
  },
    {
    version: "1.4.8.1",
    github:
      "https://github.com/BusinessTSG/Pipsqueak-Network-Scanner/releases/download/v1.4.8.1/Pipsqueak-windows-x64-latest.exe",
    s3:
      "https://myexefilebucket.s3.eu-north-1.amazonaws.com/Pipsqueak-windows-x64-1.4.8.1.exe",
    sha256: "e69a96383663ed3e3ebde11adb04383bad3f4f3766346300a01cbba73e82fbe5",
    vt: "https://www.virustotal.com/gui/file/e69a96383663ed3e3ebde11adb04383bad3f4f3766346300a01cbba73e82fbe5",
  },
    {
    version: "1.4.8",
    github:
      "https://github.com/BusinessTSG/Pipsqueak-Network-Scanner/releases/download/v1.4.8/Pipsqueak-windows-x64-latest.exe",
    s3:
      "https://myexefilebucket.s3.eu-north-1.amazonaws.com/Pipsqueak-windows-x64-1.4.8.exe",
    sha256: "8bb567a9a3f781c2d4e4224dc70092384dc4120ec385ab8091e919ad2e1acd49",
    vt: "https://www.virustotal.com/gui/file/8bb567a9a3f781c2d4e4224dc70092384dc4120ec385ab8091e919ad2e1acd49",
  },
    {
    version: "1.4.7",
    github:
      "https://github.com/BusinessTSG/Pipsqueak-Network-Scanner/releases/download/v1.4.7/Pipsqueak-windows-x64-.exe",
    s3:
      "https://myexefilebucket.s3.eu-north-1.amazonaws.com/Pipsqueak-windows-x64-1.4.7.exe",
    sha256: "0f0495ce78c9d29e299b8eb417174d4c8b348c64eb7eac2be8264a87855b569d",
    vt: "https://www.virustotal.com/gui/file/0f0495ce78c9d29e299b8eb417174d4c8b348c64eb7eac2be8264a87855b569d",
  },
    {
      version: "1.4.6",
      github:
        "https://github.com/BusinessTSG/Pipsqueak-Network-Scanner/releases/download/v1.4.6/Pipsqueak-windows-x64-latest.exe",
      s3:
        "https://myexefilebucket.s3.eu-north-1.amazonaws.com/Pipsqueak-windows-x64-1.4.6.exe",
      sha256: "ea41a30d034b6e6f9d51f3e9cbe6640ddb6b602152b873e907cb9cde1c8f8df4",
      vt: "https://www.virustotal.com/gui/file/ea41a30d034b6e6f9d51f3e9cbe6640ddb6b602152b873e907cb9cde1c8f8df4",
    },
    {
      version: "1.4.5",
      github:
        "https://github.com/BusinessTSG/Pipsqueak-Network-Scanner/releases/download/v1.4.5/Pipsqueak-windows-x64-latest.exe",
      s3:
        "https://myexefilebucket.s3.eu-north-1.amazonaws.com/Pipsqueak-windows-x64-1.4.5.exe",
      sha256:
        "bcebe7999a7185ffec403e2aaaa9e8d020802ef4c7ec3aa4186c816e9c41e9a3",
      vt:
        "https://www.virustotal.com/gui/file/bcebe7999a7185ffec403e2aaaa9e8d020802ef4c7ec3aa4186c816e9c41e9a3",
    },
    {
      version: "1.4.4",
      github:
        "https://github.com/BusinessTSG/Pipsqueak-Network-Scanner/releases/download/v1.4.4/Pipsqueak-windows-x64-latest.exe",
      s3:
        "https://myexefilebucket.s3.eu-north-1.amazonaws.com/Pipsqueak-windows-x64-1.4.4.exe",
      sha256:
        "171ec27b65258ee368b0e9ae44f81d7f4c00e6f63b9dc024c4d1596df1e3f475",
      vt:
        "https://www.virustotal.com/gui/file/171ec27b65258ee368b0e9ae44f81d7f4c00e6f63b9dc024c4d1596df1e3f475",
    },
  ];

  return (
    <Container className="d-flex justify-content-center py-5">
      <Card className={`shadow-lg p-4 w-100 ${themeClass}`} style={{ maxWidth: 700 }}>
        <Card.Body>
          <h2 className="text-center mb-4">
            Pipsqueak Network Scanner
          </h2>

          <p><strong>Version:</strong> {current.version}</p>
          <p><strong>Release Date:</strong> {current.releaseDate}</p>

          <p><strong>SHA256:</strong></p>
          <pre className={isDarkMode ? "bg-secondary text-light p-2 rounded" : "bg-light p-2 rounded"}>
            {current.sha256}
          </pre>

          <h4 className="mt-4">Download</h4>
          <Button className="w-100 mb-3" variant="primary" href={current.s3} target="_blank">
            Download from S3
          </Button>

          <Button className="w-100 mb-2" variant="secondary" href={current.github} target="_blank">
            Download from GitHub
          </Button>

          <p>The GitHub download link does not work on the site unless you have a GitHub account.</p>

          <Button variant="info" href={current.vt} target="_blank">
            View VirusTotal Scan
          </Button>

          <hr className="my-4" />

          <Button
            variant="outline-info"
            className="w-100 mb-3"
            onClick={() => setShowPrevious(!showPrevious)}
          >
            {showPrevious ? "Hide Previous Versions" : "Show Previous Versions"}
          </Button>

          <Collapse in={showPrevious}>
            <div>
              {previousVersions.map((v) => (
                <Card key={v.version} className={`${themeClass} p-3 mb-3`}>
                  <h5>Version {v.version}</h5>

                  <p><strong>SHA256:</strong></p>
                  <pre>{v.sha256}</pre>

                  <Button className="w-100 mb-2" href={v.github} target="_blank">
                    Download from GitHub
                  </Button>
                  <Button className="w-100 mb-2" variant="info" href={v.s3} target="_blank">
                    Download from S3
                  </Button>
                  <Button className="w-100" variant="secondary" href={v.vt} target="_blank">
                    View VirusTotal
                  </Button>
                </Card>
              ))}
            </div>
          </Collapse>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default DownloadPage;
